import React from 'react';
import { RootState } from 'reducers';
import { RouteComponentProps } from 'react-router-dom';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import { ArrowLeftBlack, ArrowRightBlack } from 'assets/icons';
import moment from 'moment';
import { ServiceService } from 'services';
import { Input, Select } from 'components';

interface Props {
	onClose?: any;
	item?: any;
}

class ModalCalendar extends React.Component<Props> {

	calendar: any;

	state = {
		currentYear: moment().format('YYYY'),
		currentMonth: moment().format('MMMM'),
		events: [],
		price: 0,
		accessory_price: 0,
		title: '',
		selected_day: null
	}

	componentDidMount() {
		window.dispatchEvent(new Event('resize'));

		this.load();
	}

	load = async () => {
		const res: any = await ServiceService.admin.getSpecialDays();
		this.setState({
			price: res.special_day_price?.price || 0,
			accessory_price: res.special_day_price?.accessory_price || 0,
			title: res.special_day_price?.title || '',
			events: res.special_days.map((i: any) => {
				return {
					date: i.day,
					price: i.price
				}
			})
		});
	}

	save = async () => {
		await ServiceService.admin.setSpecialDays({
			dates: JSON.stringify(this.state.events),
			price: this.state.price,
			title: this.state.title,
			accessory_price: this.state.accessory_price
		});
		this.props.onClose();
	}

	updateDate = () => {
		this.setState({
			currentYear: moment(this.calendar?.getApi().getDate()).format('YYYY'),
			currentMonth: moment(this.calendar?.getApi().getDate()).format('MMMM')
		});
	}

	setAllDays = (day: string) => {
		let date = moment(this.state.currentYear + '-' + this.state.currentMonth,'YYYY-MMMM').startOf('month');
		const last_date = moment(this.state.currentYear + '-' + this.state.currentMonth,'YYYY-MMMM').endOf('month');
		let dates: any = [];
		while(date < last_date) {
			if (moment(date).format('ddd') == (day + '.') && moment(date) >= moment()) {
				dates.push(date.format('YYYY-MM-DD'));
			}
			date = date.add(1,'day');
		}
		let events: any = [...this.state.events];
		const count_days = events.filter((i: any) => moment(i.date).format('ddd') == (day + '.') && moment(i.date).format('YYYY-MMMM') == (this.state.currentYear + '-' + this.state.currentMonth)).length;
		events = events.filter((i: any) => moment(i.date).format('ddd') != (day + '.') || moment(i.date).format('YYYY-MMMM') != (this.state.currentYear + '-' + this.state.currentMonth));
		if (count_days < dates.length) {
			dates.forEach((date: string) => {
				events.push({
					date
				});
			});
		}
		this.setState({
			events
		});
	}
	
	render() {
		const index_day = this.state.events.findIndex((i: any) => i.date == this.state.selected_day);

		return (
			<div id="modal-calendar-bookings">
				<h3>Días con recargo</h3>

				<p className="type">{ this.props.item?.name }</p>

				<div className="row">
					<div className="col-lg-6">
						<div className="container-arrow">
							<button className="btn btn-arrow" onClick={ () => {
								this.calendar.getApi().prevYear();
								this.updateDate();
							} }>
								<img src={ ArrowLeftBlack } />
							</button>
							<h4>{ this.state.currentYear }</h4>
							<button className="btn btn-arrow" onClick={ () => {
								this.calendar.getApi().nextYear();
								this.updateDate();
							} }>
								<img src={ ArrowRightBlack } />
							</button>
						</div>
					</div>
					<div className="col-lg-6">
						<div className="container-arrow">
							<button className="btn btn-arrow" onClick={ () => {
								this.calendar.getApi().prev();
								this.updateDate();
							} }>
								<img src={ ArrowLeftBlack } />
							</button>
							<h4>{ this.state.currentMonth }</h4>
							<button className="btn btn-arrow" onClick={ () => {
								this.calendar.getApi().next();
								this.updateDate();
							} }>
								<img src={ ArrowRightBlack } />
							</button>
						</div>
					</div>
				</div>
				<FullCalendar
					ref={ ref => this.calendar = ref }
			        plugins={[ dayGridPlugin ]}
			        initialView="dayGridMonth"
			        locale="es"
			        dayHeaderContent={ (args: any) => {
			        	return (
			        		<button className="btn day-container" onClick={ () => this.setAllDays(args.text) }>
								<p>{ args.text.substring(0,2) }</p>
		        			</button>
			        	)
			        } }
			        events={ this.state.events }
		        	eventContent={(eventInfo) => {
		        		// @ts-ignore
		        		const date = moment(eventInfo.event.start).format('YYYY-MM-DD');

		        		return (
		        			<button disabled={ date < moment().format('YYYY-MM-DD') } className="btn event-container" onClick={ () => {
		        				let events: any = [...this.state.events];
		        				const index = events.findIndex((i: any) => i.date == date);
		        				if (index == -1) {
		        					events.push({
			        					date
			        				});
		        				}
		        				else {
		        					events.splice(index,1);
		        				}
		        				this.setState({
		        					events
		        				});
		        			} }>
		        				{/*
		        				// @ts-ignore */}
		        				<p>{ moment(eventInfo.event.start).format('D') }</p>
		        			</button>
		        		)
		        	}}

		        	dayCellContent={ (info) => {
		        		const date = moment(info.date).format('YYYY-MM-DD');

		        		return (
		        			<button disabled={ date < moment().format('YYYY-MM-DD') } className="btn day-container" onClick={ () => {
		        				let events: any = [...this.state.events];
		        				const index = events.findIndex((i: any) => i.date == date);
		        				if (index == -1) {
		        					events.push({
			        					date
			        				});
		        				}
		        				else {
		        					events.splice(index,1);
		        				}
		        				this.setState({
		        					events
		        				});
		        			} }>
								<p>{ moment(info.date).format('D') }</p>
		        			</button>
		        		)
		        	} }
			        headerToolbar={{
			        	left: '',
			        	center: '',
			        	right:  ''
			        }}
			    />

			    <div className="row row-price">
			    	<div className="col-md-12">
					    <Input
							type="decimal"
							color="white"
							value={ this.state.price }
							label="Monto de recargo"
							onChange={ (e: any) => {
								this.setState({
									price: e.target.value
								});
							} } />
					</div>
					<div className="col-md-12">
					    <Input
							type="decimal"
							color="white"
							value={ this.state.accessory_price }
							label="Monto de recargo (Complementos)"
							onChange={ (e: any) => {
								this.setState({
									accessory_price: e.target.value
								});
							} } />
					</div>
			    	<div className="col-md-12">
					    <Input
							color="white"
							value={ this.state.title }
							label="Título"
							onChange={ (e: any) => {
								this.setState({
									title: e.target.value
								});
							} } />
					</div>
					<div className="col-md-12">
						<p className="label-message">Cambiar monto de recargo</p>
						<p className="message">Seleccione un día de la lista para cambiar su monto de recargo</p>
					</div>
					<div className="col-md-6">
						<Select
							placeholder="Día"
							name="selected_day"
							onChange={ (e: any) => this.setState({
								selected_day: e.target.value
							}) }
							value={ this.state.selected_day }
							options={ this.state.events.map((item: any) => {
								return {
									value: item.date,
									label: moment(item.date).format('DD-MM-YYYY')
								}
							}) } />
			    	</div>
			    	{
			    		this.state.selected_day != null && (
			    			<div className="col-md-6">
							    <Input
									type="decimal"
									color="white"
									// @ts-ignore
									value={ this.state.events[index_day]?.price || '' }
									placeholder="Monto de recargo del día"
									onChange={ (e: any) => {
										let events: any = [...this.state.events];
										events[index_day].price = e.target.value;
										this.setState({
											events
										});
									} } />
							</div>
			    		)
			    	}
				</div>

				<div className="row">
					<div className="col-6 text-center">
						<button className="btn btn-cancel" onClick={ () => this.props.onClose() }>
							Cerrar
						</button>
					</div>
					<div className="col-6 text-center">
						<button className="btn btn-save" onClick={ () => this.save() }>
							Guardar
						</button>
					</div>
				</div>
			</div>
		)
	}
}

export default ModalCalendar;